import React from 'react';
import ReactDOM from 'react-dom/client';

import { Providers } from './app/providers';
import { Router } from './app/router';
import './styles/global.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Providers>
      <Router />
    </Providers>
  </React.StrictMode>,
);
